// @ts-check
import React from "react";
import "../../shared/styles/shared-styles.css";

export const JobOverlapModal = ({message, cancel}) => (
  <div data-testid="job-overlap-modal" className="shift-modal-container">
    <div className="modal-body">
      <img src="images/employer-svg/icon-modal-calendar.svg" />
      <span className="modal-body-header">Job overlap</span>
      <span className="modal-body-description">{message}</span>
      <button
        className="modal-button modal-confirm-button"
        onClick={cancel}
      >
        OK
      </button>
    </div>
  </div>
);
